export const GET_LIST_PRODUCTS_ACTION = "GET_LIST_PRODUCTS_ACTION";
export const SET_LIST_PRODUCTS_ACTION = "SET_LIST_PRODUCTS_ACTION";

export const SET_CART_ACTION = "SET_CART_ACTION";

export const CALCULLATE_CART_ACTION = "CALCULLATE_CART_ACTION";
export const SET_CALCULLATE_CART_ACTION = "SET_CALCULLATE_CART_ACTION";

export const SET_SELECT_PRODUCT_DRAFT_ACTION =
	"SET_SELECT_PRODUCT_DRAFT_ACTION";

export const GET_DATA_CALCALATE_CART_ACTION = "GET_DATA_CALCALATE_CART_ACTION";
export const SET_DATA_CALCALATE_CART_ACTION = "SET_DATA_CALCALATE_CART_ACTION";

export const POST_CREATE_ORDER_ACTION = "POST_CREATE_ORDER_ACTION";

export const GET_LIST_HISTORY_ORDER_ACTION = "GET_LIST_HISTORY_ORDER_ACTION";
export const SET_LIST_HISTORY_ORDER_ACTION = "SET_LIST_HISTORY_ORDER_ACTION";

export const GET_ORDER_HISTORY_DETAIL_ACTION =
	"GET_ORDER_HISTORY_DETAIL_ACTION";
export const SET_ORDER_HISTORY_DETAIL_ACTION =
	"SET_ORDER_HISTORY_DETAIL_ACTION";

export const SET_DATA_HISTORY_DETAIL_ACTION = "SET_DATA_HISTORY_DETAIL_ACTION";

export const SET_DATA_ID_PROMOTION_CHOOSES_ACTION =
	"SET_DATA_ID_PROMOTION_CHOOSES_ACTION";

export const SET_DEFAULT_CART_ACTION = "SET_DEFAULT_CART_ACTION";

export const SET_MENU_CHILDREN_HISTORY_ACTION =
	"SET_MENU_CHILDREN_HISTORY_ACTION";
export const SET_MENU_PARENT_HISTORY_ACTION = "SET_MENU_PARENT_HISTORY_ACTION";

export const GET_MENU_PRODUCT_BRANDS_ACTION = "GET_MENU_PRODUCT_BRANDS_ACTION";
export const SET_MENU_PRODUCT_BRANDS_ACTION = "SET_MENU_PRODUCT_BRANDS_ACTION";
